<template>
  <div>
    <div
      :class="
        getExpand && checkActive ? 'selected-folder' : 'unselected-folder'
      "
      @click="
        modalType == 'Recruiter' ||
        modalType == 'Panelists' ||
        modalType == 'User'
          ? getFolderDetails()
          : getPanelFolderDetails()
      "
      class="d-flex align-items-center relativeclass"
    >
      <div
        v-if="getExpand && !checkActive"
        class="gridgreencolorDynamic mr-3"
      ></div>

      <div v-else-if="checkActive" class="gridwhitecolorDynamic"></div>

      <div class="d-flex align-items-center justify-content-between w-100">
        <div
          class="ml-2"
          @click.stop=""
          v-if="modalType == 'Recruiter' || modalType == 'Panelists'"
        >
          <b-form-checkbox
            size="sm"
            name="checkbox-1"
            :value="folder.folderID"
            v-model="selectedFolders"
            @input="$emit('check-folderID', folder.folderID)"
          >
            <span
              :class="{
                'selected-folder-text': getExpand && checkActive,
                'unselected-folder-text': !getExpand || !checkActive,
              }"
              >{{ folder.folderName }}</span
            >
          </b-form-checkbox>
        </div>
        <div
          class="ml-2"
          @click.stop=""
          v-else-if="modalType == 'selectpanel' || modalType == 'User'"
        >
          <span
            :class="{
              'selected-folder-text': getExpand && checkActive,
              'unselected-folder-text': !getExpand || !checkActive,
            }"
            >{{ folder.folderName }}</span
          >
        </div>

        <img
          v-if="hasChildren && !getExpand && level == 1"
          src="../../assets/img/roundcust/rooticon.svg"
          alt=""
        />
        <img
          v-else-if="hasChildren && getExpand && !checkActive && level == 1"
          src="../../assets/img/roundcust/rootopeninactive.svg"
          alt=""
        />
        <img
          v-else-if="hasChildren && getExpand && level == 1"
          src="../../assets/img/roundcust/whitedownsvg.svg"
          alt=""
        />
        <img
          v-else-if="hasChildren && !getExpand && level != 1"
          src="../../assets/img/roundcust/subfoldericon.svg"
          alt=""
        />
        <img
          v-else-if="hasChildren && getExpand && level != 1 && checkActive"
          src="../../assets/img/roundcust/subfolderopen.svg"
          alt=""
        />
        <img
          v-else-if="hasChildren && getExpand && !checkActive && level != 1"
          src="../../assets/img/roundcust/subopeninactive.svg"
          alt=""
        />
      </div>
    </div>
    <div
      v-for="folders in folder.childFolders"
      :key="folders.folderID"
      :style="{ 'margin-left': `${depth + 5}px` }"
      class="mt-2"
    >
      <FolderCard
        v-show="getExpand"
        :folder="folders"
        :depth="depth + 5"
        :level="level + 1"
        @check-folderID="checkFolderCard"
        @update-folderup="updateFolderUp"
        :folderSelectionState="folderSelectionState"
      >
      </FolderCard>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "FolderCard",
  props: {
    folder: Object,
    depth: Number,
    level: Number,
    folderSelectionState: String,
    selectPanelPath: {
      type: Function,
    },
  },
  data() {
    return {
      selectedFolders: [],
      searchPan: "",
      searchUser: "",
      searchSubFolder: "",
      selectedUsers: [],
      folderUp: {},
    };
  },
  created() {
    if (this.selectedParentFolders.includes(this.folder.folderID)) {
      this.selectedFolders.push(this.folder.folderID);
    }
    this.$store.commit("folderVUEX/addExpand", {
      folderID: this.folder.folderID,
      expand: false,
      level: this.level,
    });
  },
  watch: {
    folderSelectionState() {
      let index = this.selectedFolders.indexOf(this.activeFolderID);
      if (this.folderSelectionState === "add") {
        if (index === -1) {
          this.selectedFolders.push(this.activeFolderID);
        }
      } else if (index != -1) {
        this.selectedFolders.splice(index, 1);
      }
    },
  },
  computed: {
    ...mapGetters("folderVUEX", {
      folderExpandList: "getExpandList",
      activeFolderID: "getActiveFolderID",
      activeFolder: "getActiveFolder",

      modalType: "getModalType",
      selectedParentFolders: "getSelectedFolderIDs",
    }),
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
    }),
    getIndex() {
      return this.folderExpandList.findIndex(
        (folder) => folder.folderID === this.folder.folderID
      );
    },
    getExpand() {
      let index = this.getIndex;
      if (index == -1) {
        return false;
      }
      return this.folderExpandList[index].expand;
    },
    checkActive() {
      return this.activeFolderID == this.folder.folderID;
    },
    hasChildren() {
      return this.folder.childFolders.length > 0;
    },
    getExactRole() {
      return this.modalType === "Recruiter"
        ? "GET_JOBDASHBOARD"
        : "GET_PANEL_DASHBOARD";
    },
  },
  methods: {
    updateFolderUp(folderUp) {
      this.$emit("update-folderup", folderUp);
    },
    checkFolderCard(folderID) {
      this.$emit("check-folderID", folderID);
    },
    getFolderDetails() {
      let index = this.getIndex;
      let expandFolder = this.folderExpandList[index].expand;
      if (expandFolder && !this.checkActive) {
        this.getSelectedFolder();
        this.$store.commit(
          "folderVUEX/setActiveFolderID",
          this.folder.folderID
        );
      } else if (!expandFolder) {
        this.getSelectedFolder();
        this.$store.commit("folderVUEX/flipExpand", { index, flag: true });
        this.$store.commit(
          "folderVUEX/setActiveFolderID",
          this.folder.folderID
        );
      } else if (expandFolder && this.checkActive) {
        this.$store.commit("folderVUEX/setActiveFolder", {});
        this.$store.commit("folderVUEX/flipExpand", { index, flag: false });
        this.$store.commit("folderVUEX/setActiveFolderID", "");
      }
    },

    getPanelFolderDetails() {
      let index = this.getIndex;
      this.$emit("stop-spinner", true);

      let expandFolder = this.folderExpandList[index].expand;
      if (expandFolder && !this.checkActive) {
        this.getPanelFolder();
        this.$store.commit(
          "folderVUEX/setActiveFolderID",
          this.folder.folderID
        );
      } else if (!expandFolder) {
        this.getPanelFolder();
        this.$store.commit("folderVUEX/flipExpand", { index, flag: true });
        this.$store.commit(
          "folderVUEX/setActiveFolderID",
          this.folder.folderID
        );
      } else if (expandFolder && this.checkActive) {
        this.$store.commit("folderVUEX/setActiveFolder", {});
        this.$store.commit("folderVUEX/flipExpand", { index, flag: false });
        this.$store.commit("folderVUEX/setActiveFolderID", "");
      }

      this.$emit("selectPanelPath");
    },

    async getSelectedFolder() {
      if (this.modalType === "User") {
        let payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          folderID: this.folder.folderID,
        };
        let response = await this.$store.dispatch(
          "folderVUEX/getSelectedFolder",
          payload
        );
        this.folderUp = response.data.data.folderUp;
        this.$emit("update-folderup", this.folderUp);
      } else {
        let payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          folderID: this.folder.folderID,
          exactRole: this.getExactRole,
        };
        let response = await this.$store.dispatch(
          "folderVUEX/getSelectedFolder",
          payload
        );
        this.folderUp = response.data.data.folderUp;
        this.$emit("update-folderup", this.folderUp);
      }
    },

    async getPanelFolder() {
      let payload = {
        jobID: this.$route.query.jobID,
        searchFolder: this.searchPan,
        folderID: this.folder.folderID,
        searchUser: this.searchUser,
        searchSubFolder: this.searchSubFolder,
      };
      this.$store.dispatch("folderVUEX/getPanelists", payload).then((res) => {
        if (res.status == 200) {
          let users = res.data.data.content.users;
          this.$emit("stop-spinner", false);

          for (const user of users) {
            this.selectedUsers.push(user.userID);
          }
        }
      });
    },
  },
};
</script>

<style>
.unselected-folder {
  background: #fcfcfc;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.selected-folder {
  background: #3e85bd;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.selected-folder-text {
  font-weight: 500;
  font-size: 14px;
  color: #fcfcfc;
}

.unselected-folder-text {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.gridgreencolorDynamic {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  top: 2px;
  left: 3px;
  background: #696969;
}

.gridwhitecolorDynamic {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  top: 2px;
  left: 3px;
  background: #f6f6f6;
}
</style>
